module.exports = __webpack_public_path__ + "static/1_1_example-2-5185fdbc675cdb8563bd229723838901.svg";